const f = (physical, v1, v2, donations, shipping) => {
  let total = physical ? 1200 : 500;
  if (v1) total += 500;
  if (v2) total += 500;
  if (donations.innocence) total += donations.innocence.replace(".", "") * 1;
  if (donations.form) total += donations.form.replace(".", "") * 1;
  if (shipping) total += shipping.rate.replace(".", "") * 1;
  return total / 100;
};

export default f;
